import { Row, Text } from "@/components";
import { MediaThumbnail } from "@/components/upload-media/MediaThumbnail";

import { MediaLink } from "@/types";

export const GeneralMedia = ({
  mediaLinks,
  onDelete,
}: {
  mediaLinks: MediaLink[];
  onDelete: (companyFileId: number | null, id: string) => void;
}) => {
  const render = () => {
    /* Render — empty state */
    if (mediaLinks.length === 0) {
      return (
        <Text className="text-xs italic" variant="muted">
          Add photos and videos to help the staffing team gain context on this
          company — facility tours, product demos, etc.
        </Text>
      );
    }

    /* Render */
    return (
      <Row className="flex-wrap gap-2">
        {mediaLinks.map((media) => (
          <MediaThumbnail
            key={media.id}
            onDelete={() => {
              onDelete(media.companyFileId, media.id);
            }}
            type={media.type}
            url={media.url ?? ""}
          />
        ))}
      </Row>
    );
  };

  return render();
};
